import React, {useState} from 'react';
import axios from 'axios';
import { OverlayTrigger, Tooltip, Form, Alert, Button, Modal, Row, Col } from 'react-bootstrap';
import { validateClient } from '../Validateclient/Validateclient';
import API from '../../../../api';

export default function Editclient( {
        listItem,
        loadClientList,
        cityList,
        loggedInUserData,
        buttonTitle
}) {
    const [name, setName] = useState(listItem.name);
    const [clientId, setClientId] = useState(listItem.client_id);
    const [birthDate, setBirthDate] = useState(listItem.birth_date);
    const [gender, setGender] = useState(listItem.gender);
    const [phone, setPhone] = useState(listItem.phone);
    const [email, setEmail] = useState(listItem.email);
    const [zip, setZip] = useState(listItem.zip);
    const [cityId, setCityId] = useState(listItem.city_id);
    const [street, setStreet] = useState(listItem.street);
    const [houseNumber, setHouseNumber] = useState(listItem.house_number);
    const [floor, setFloor] = useState(listItem.floor);
    const [door, setDoor] = useState(listItem.door);
    const [disableSubmitButton, setDisableSubmitButton] = useState(false);
    const [errorMessage, setErrorMessage] = useState({
        name : '',
        clientId : '',
        birthDate : '',
        gender : '',
        zip : '',
        city : '',
        phone : '',
        email : '',
        error : false,
    });

    const [showEditClientForm, setShowEditClientForm] = useState(false);

	const handleCloseEditClientForm = () => {
        setShowEditClientForm(false);
        setName(listItem.name);
		setClientId(listItem.client_id);
        setBirthDate(listItem.birth_date);
        setGender(listItem.gender);
        setZip(listItem.zip);
		setCityId(listItem.city_id);
		setStreet(listItem.street);
		setHouseNumber(listItem.house_number);
		setFloor(listItem.floor);
		setDoor(listItem.door);
        setPhone(listItem.phone);
		setEmail(listItem.email);
 	 	setErrorMessage({
            name : '',
			clientId : '',
            birthDate : '',
            gender : '',
            zip : '',
			city : '',
            phone : '',
            email : '',
			error : false, 
		})

    }

    const handleShowEditClientForm = (e) => {
        e.stopPropagation();
		setShowEditClientForm(true);
    }

    const handleEditClientSubmit = async (e) => {
        setDisableSubmitButton(true);
		e.preventDefault();
		const tempErrorMessage = await validateClient(name, clientId, listItem.client_id, birthDate, gender, email, phone, zip, cityId, listItem.id, loggedInUserData);
		setErrorMessage(tempErrorMessage);
 		if (! tempErrorMessage.error) {
			axios.post(`${API.address}/editclient`, {
                name : name.trim(),
                id : listItem.id,
                clientid : clientId,
                birthdate : birthDate,
                gender : gender,
                cityid : cityId,
                street : street.trim(),
                housenumber : houseNumber.trim(),
                floor : floor.trim(),
                door : door.trim(),
                phone : phone.trim(),
                email : email.trim()},
                {headers: { 'x-api-key': loggedInUserData.password }})
		    .then(() => {
                setShowEditClientForm(false);
                loadClientList();
                setDisableSubmitButton(false);
		    });
		} else setDisableSubmitButton(false);
	}

    const renderTooltip = (props) => (
        <Tooltip id="edit-button-tooltip" {...props}>
          Szerkesztés
        </Tooltip>)

    function findCity(zip) {
        const findedCity = cityList.find((cityListItem) => cityListItem.zip === zip)
        if (findedCity !== undefined) return findedCity.id
            else return 0
    }   

    function findZip(id) {
        const findedZip = cityList.find((cityListItem) => cityListItem.id === Number(id))
        return findedZip.zip
    }

    const editClientButton = 
        <Button 
            size={buttonTitle === undefined ? "sm" : ''}
            className = "m-1"
            variant = "info"
            onClick = {handleShowEditClientForm}>
            {buttonTitle ? buttonTitle : <>&#x270D;</>}
        </Button>
return (
    <>  
        {buttonTitle === undefined ? <OverlayTrigger
			placement="top"
			delay={{ show: 50, hide: 100 }}
			overlay={renderTooltip}>
			{editClientButton}
	    </OverlayTrigger>:
            editClientButton}
        <Modal 
            show={showEditClientForm} 
            onHide={handleCloseEditClientForm}
            backdrop='static'
            onClick={(e)=>e.stopPropagation()}>
            <Modal.Header closeButton> 
                <Modal.Title>Ügyfél módosítása</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleEditClientSubmit}>
                <Row className='mb-3'>
                        <Col xs={12} sm={8}>
                    <Form.Group className='mb-3' controlId="formName">
                        <Form.Label>Név</Form.Label>
                        {errorMessage.name === '' ? '' : <Alert variant='danger' size="sm">{errorMessage.name}</Alert>}
                        <Form.Control 
                            autoComplete="name"
                            maxLength={100}
                            type='text'
                            value={name}
                            onChange={(e) => setName(e.target.value)}/>
                    </Form.Group>
                    </Col>
                    <Col xs={12} sm={4}>
                    <Form.Group className='mb-3' controlId="formId">
                        <Form.Label>Azonosító</Form.Label>
                        {errorMessage.clientId === '' ? '' : <Alert variant='danger' size="sm">{errorMessage.clientId}</Alert>}
                        <Form.Control 
                            autoComplete="on"
                            maxLength={9}
                            type='text'
                            value={clientId}
                            onChange={(e) => setClientId(e.target.value)}/>
                    </Form.Group>
                    </Col>
                    </Row>
                    <Row className='mb-3'>
                        <Col xs={12} sm={6}>
                            <Form.Group controlId="formBirthDate">
                                <Form.Label>Születési dátum</Form.Label>
                                {errorMessage.birthDate === '' ? '' : <Alert variant='danger' size="sm">{errorMessage.birthDate}</Alert>}
                                <Form.Control
                                    type='date'
                                    value={birthDate}
                                    onChange={(e) => setBirthDate(e.target.value)}/>
                            </Form.Group>
                        </Col>
                        <Col xs={12} sm={6}>
                            <Form.Group controlId="formSelectFromGender">
                                <Form.Label>Nem</Form.Label>
                                {errorMessage.gender === '' ? '' : <Alert variant='danger' size="sm">{errorMessage.gender}</Alert>}
                                <Form.Select value={gender} onChange={(e) => setGender(e.target.value)}>
                                    <option key='0' value=''>Válassz nemet!</option>
                                    <option key='man' value='férfi'>férfi</option>
                                    <option key='woman' value='nő'>nő</option>
                                </Form.Select>	
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className='mb-3'>
                        <Col xs={12} sm={6}>
                            <Form.Group controlId="formEmail">
                                <Form.Label>E-mail</Form.Label>
                                {errorMessage.email === '' ? '' : <Alert variant='danger' size="sm">{errorMessage.email}</Alert>}
                                <Form.Control 
                                    autoComplete="email"
                                    type='e-mail'
                                    value={email}
                                    maxLength={100}
                                    onChange={(e) => setEmail(e.target.value)}/>
                            </Form.Group>
                        </Col>
                        <Col xs={12} sm={6}>
                            <Form.Group controlId="formPhone">
                                <Form.Label>Mobil</Form.Label>
                                {errorMessage.phone === '' ? '' : <Alert variant='danger' size="sm">{errorMessage.phone}</Alert>}
                                <Form.Control 
                                    autoComplete="tel"
                                    maxLength={12}
                                    type='tel'
                                    placeholder='+36.........'
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}/>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className='mb-3'>
                        <Col xs={12} sm={4}>
                            <Form.Group controlId="formZip">
                                <Form.Label>Irányítószám</Form.Label>
                                {errorMessage.zip === '' ? '' : <Alert variant='danger' size="sm">{errorMessage.zip}</Alert>}
                                <Form.Control 
                                    autoComplete="postal-code"
                                    maxLength={4}
                                    type='text'
                                    value={zip}
                                    onChange={(e) => {
                                        setZip(e.target.value.replace(/\D/g, ""))
                                        e.target.value.length === 4 ? setCityId(findCity(e.target.value)) : setCityId(0)
                                    }}/>
                            </Form.Group>
                        </Col>
                        <Col xs={12} sm={8}>
                        <Form.Group md="4" controlId="formSelectCity">
                            <Form.Label>Város</Form.Label>
                            {errorMessage.city === '' ? '' : <Alert variant='danger' size="sm">{errorMessage.city}</Alert>}
                            <Form.Select 
                                onChange={(e) => {
                                    setCityId(e.target.value)
                                    e.target.value !== '0' ? setZip(findZip(e.target.value)) : setZip('')
                                }}
                                value={cityId}
                            >				
                                <option key={0} value={0}>Válassz várost!</option>
                                {cityList.map((cityListItem) => 
                                    <option 
                                        key={cityListItem.id}
                                        value={cityListItem.id}>
                                        {cityListItem.city}
                                    </option>)}
                            </Form.Select>
                        </Form.Group>
                        </Col>
                    </Row>
                    <Row className='mb-3'>
                        <Col xs={12} sm={6}>
                            <Form.Group controlId="formStreet">
                                <Form.Label>Utca</Form.Label>
                                <Form.Control 
                                    autoComplete="on"
                                    maxLength={100}
                                    type='text'
                                    value={street}
                                    onChange={(e) => setStreet(e.target.value)}/>
                            </Form.Group>
                        </Col>
                        <Col xs={3} sm={2}>
                            <Form.Group controlId="formHouseNumber">
                                <Form.Label>Házszám</Form.Label>
                                <Form.Control 
                                    autoComplete="on"
                                    maxLength={5}
                                    type='text'
                                    value={houseNumber}
                                    onChange={(e) => setHouseNumber(e.target.value)}/>
                            </Form.Group>
                        </Col>
                        <Col xs={3} sm={2}>
                            <Form.Group controlId="formFloor">
                                <Form.Label>Emelet</Form.Label>
                                <Form.Control 
                                    autoComplete="on"
                                    maxLength={3}
                                    type='text'
                                    value={floor}
                                    onChange={(e) => setFloor(e.target.value)}/>
                            </Form.Group>
                        </Col>
                        <Col xs={3} sm={2}>
                            <Form.Group controlId="formDoor">
                                <Form.Label>Ajtó</Form.Label>
                                <Form.Control 
                                    autoComplete="on"
                                    maxLength={4}
                                    type='text'
                                    value={door}
                                    onChange={(e) => setDoor(e.target.value)}/>
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseEditClientForm}>
                Mégse
            </Button>
            <Button variant="primary" onClick={handleEditClientSubmit} disabled={disableSubmitButton}>
                Rögzít
            </Button>
            </Modal.Footer>
        </Modal>
    </>
    )
};